import { OpenInterestChartSettings } from '../components/chartV2/chart.typings'

export const defaultOpenInterestChartSettings: OpenInterestChartSettings = {
    showOI: false,
    replayKey: 0,
    strikeCount: '25',
    selectedExpiries: [],
    securityKey: undefined,
    expiriesMenuFromApi: [],
    expiriesMenuLoading: false,
    selectedDate: undefined,
    timeWindowMinutes: 'full',
}
